/**
 * Accordion Class
 * @class Accordion
 */

export default class Accordion {
    constructor() {
        const elem = 'accordion__element';
        this.elements = document.querySelectorAll(`.${elem}`);
        this.addClickEvent();
    }

    addClickEvent() {
        const elemHeaderClass = 'accordion__title';
        this.elements.forEach(item => {
            const elemHeader = item.querySelector(`.${elemHeaderClass}`);
            elemHeader.addEventListener('click', () => {
                this.toggleElement(item);
            });
        });
    }

    isOpen(item) {
        return item.classList.contains('accordion__element--open');
    }

    toggleElement(item) {
        const openElem = 'accordion__element--open';

        if (this.isOpen(item)) {
            item.classList.remove(openElem);
            this.closeElement(item);
        } else {
            item.classList.add(openElem);
            this.openElement(item);
        }
    }

    openElement(item) {
        const contentHeight = this.calcContentHeight(item);
        const contentElem = item.querySelector('.accordion__container');
        contentElem.style.height = `${contentHeight}px`;
    }

    closeElement(item) {
        const contentElem = item.querySelector('.accordion__container');
        contentElem.style.height = 0;
    }

    calcContentHeight(item) {
        return item.querySelector('.accordion__container-wrapper').offsetHeight;
    }
}